import RightSidebarDesktop from './RightSidebarDesktop';

// Note: Mobile uses bottom sheets in views, not slide-in drawers
// Only render desktop version (AppMain already gates this with isDesktop)
export default function RightSidebar({ isOpen, onClose, activeFilter, onFilterChange, ...props }) {
  // Only render desktop version (AppMain already gates this with isDesktop)
  return <RightSidebarDesktop activeFilter={activeFilter} onFilterChange={onFilterChange} {...props} />;
}
